<template>
  <div v-if="isDev" class="fixed-ribbon"><span>Dev</span></div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api'
import useComp from '../../composables/useComp'

export default defineComponent({
  name: 'FixedRibbon',
  setup() {
    const { isDev } = useComp()
    return {
      isDev
    }
  }
})
</script>
